document.getElementById("start-game")!.addEventListener("click", ()=> {

    /**
     * communicatie met API
     * Check of het live is of niet?
     * Toon dan in de game-engine enkel de "go inside" knop
     */
    window.location.assign("/game.html");
});
